export default "__VITE_ASSET__C4COpXnt__"